import Config from '../../config';
import { Grid } from '@mui/material';
import { FalconLogo, ReturnBackOutlineIcon, SignUpSucessIcon } from '../../icon';
import { Link } from 'react-router-dom';
import { AppRoutes } from '../routes/route.path';
import { ViewTextLabels } from '../shared/constants';
import { useSelector } from 'react-redux';
import * as selector from '../../selectors/selectors';
interface Props {
    FirstName: string
}

export const SucessComponent = (props: Props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    return (
        <Grid container className={`m-auto  br-4 w-p-100`}>
            <Grid item xs={12} md={12} xl={12} className='d-flex justify-center flex-direction align-center'>
                <span className={" px-10 py-2"}>
                    <FalconLogo />
                </span>
                <Grid item xs={6} md={6} xl={6} className={`${IsMobileDevice ? "pt-10" : "pl-10 pt-10" }`}>
                    <Grid container direction='column' className={`sign-up-sucess-title ${IsMobileDevice && "t-align-center"}`}>
                        Hello, Glad to see you're interested!
                    </Grid>

                    <Grid container className='h5-regular mt-2 signin-success-color'>
                        <div className={`${IsMobileDevice && "t-align-center"}`}>A member of our support team will reach out to you shortly to guide you though the onboarding process.</div>
                    </Grid>

                    <Grid>
                        <Grid container className='mt-5 d-flex justify-center'>
                            <Grid item className={`${IsMobileDevice && "mb-3"}`}>
                                <a href='https://www.falkonsms.com/'
                                    data-arrow-index={3}
                                    data-up-arrow-index={3}
                                    data-down-arrow-index={0}
                                    data-left-arrow-index={2}
                                    data-right-arrow-index={4}
                                    className={`primary-btn ${IsMobileDevice ? "px-8" : "px-6 mr-3"} py-1 h4-regular`}
                                    target="_blank" rel="noopener noreferrer">
                                    Home
                                </a>
                            </Grid>
                            <Grid item>
                                <a href='https://meetings.hubspot.com/falkon-systems/meeting'
                                    data-arrow-index={3}
                                    data-up-arrow-index={3}
                                    data-down-arrow-index={0}
                                    data-left-arrow-index={2}
                                    data-right-arrow-index={4}
                                    className={"secondary-btn color-primary-light py-1 h4-regular"}
                                    target="_blank" rel="noopener noreferrer">
                                    Schedule Demo
                                </a>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item className='d-flex justify-center'>
                        <p className={`m-auto my-5 h4-regular color-sign-up-alreadyHave-account-label c-pointer ${IsMobileDevice && "t-align-center"}`}>
                            Please <a href={`mailto:${Config.SALES_EMAIL}`}
                                data-arrow-index={3}
                                data-up-arrow-index={3}
                                data-down-arrow-index={0}
                                data-left-arrow-index={2}
                                data-right-arrow-index={4}
                                className={'color-primary-light'} target="_blank" rel="noopener noreferrer">
                                contact us
                            </a> if you require more assistance.
                        </p>
                    </Grid>
                    <Grid item className='d-flex justify-center'>
                        
                        <p className='m-auto my-2 h5-regular color-sign-up-alreadyHave-account-label d-flex align-center c-pointer'>
                            {<ReturnBackOutlineIcon/>}&nbsp;
                             Take me back to <Link tabIndex={5}
                                data-arrow-index={10}
                                data-up-arrow-index={6}
                                data-down-arrow-index={7}
                                data-left-arrow-index={2}
                                data-right-arrow-index={10}
                                to={AppRoutes.SIGN_IN} className={"color-login-link c-pointer text-style w-space m-auto"}> &nbsp;{ViewTextLabels.SIGN_IN}</Link>
                        </p>
                    </Grid>

                </Grid>
            </Grid>
        </Grid >
    )
}